const transmisionEnVivo = {
  GetAudienciasDeTransmision: 'Forseti/TransmisionEnVivo/GetAudienciasDeTransmision'
}

const transmision = {
  transmisionEnVivo: transmisionEnVivo  
}

export default transmision;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/sistema/transmision/transmision.js
// module id = null
// module chunks = 